import api from './api';

// Obtener todos los datos POS
export const getAllPOSData = async () => {
  try {
    const response = await api.get('/pos');
    return response.data;
  } catch (error) {
    console.error('Error fetching POS data:', error);
    throw error;
  }
};

// Importar datos desde CSV
export const importPOSData = async (file, storeId, onProgress) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('storeId', storeId);

    if (onProgress) onProgress(30);

    const response = await api.post('/pos/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    if (onProgress) onProgress(100);
    return response.data;
  } catch (error) {
    console.error('Error importing POS data:', error);
    throw error;
  }
};

// Eliminar un registro
export const deletePOSRecord = async (id) => {
  try {
    const response = await api.delete(`/pos/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting POS record:', error);
    throw error;
  }
};

// Limpiar todos los datos de una tienda
export const clearStorePOSData = async (storeId) => {
  try {
    const response = await api.delete(`/pos/store/${storeId}/clear`);
    return response.data;
  } catch (error) {
    console.error('Error clearing store data:', error);
    throw error;
  }
};